//老挝语
export default {
	userDrawer:{ //抽屉导航
		data:[
			{name:'ໜ້າທໍາອິດ'},
			{name:'ຊອກຫາ'},
			{name:'ຈໍາແນກ'},
			{name:'ກະຕ່າຊື້ສິນຄ້າ'},
			{name:'ເກັບຮວບຮວມ'},
			{name:'ຂອງຂ້ອຍ'},
			{name:'ພາສາ'},
		],
		language:[
			{name:'ຈີນ'},
			// {name:'ພາສາອັງກິດ'},
			// {name:'ພາສາຝຣັ່ງ'},
			// {name:'ໄທ'},
			// {name:'ພາສາລາວ'},
			{name: 'ภาษาสเปน'}
		]
	},
	page:{
		index:{ //首页
			mainNav:[
				{name:'ຈໍາແນກປະເພດ'},
				{name:'ເກັບຮວບຮວມ'},
				{name:'ໃບສັ່ງສິນຄ້າ'},
				{name:'ທີ່ຢູ່'},
			],
			coupons:'ຄູປອງ',
			titProduct:'ຜະລິດຕະພັນຫຼັກ',
			titNow:'ສິນຄ້າຂາຍດີ',
			titCate:'ຈໍາແນກພິເສດ',
			titBtn:'ກວດເບີ່ງທັງໝົດ',
			titAlso:'ໜ້າຈະມັກ',
			couponDesc:'ຍອດເງິນສັ່ງຊື້ເຕັມ',
			received:'ໄດ້ຮັບແລ້ວ',
			orMore:'ຫຼາຍກ່ວາ',
			viewDetails:'ກວດເບີ່ງລາຍລະອຽດ',
			recommended: 'ຜະລິດຕະພັນທີ່ໂດດເດັ່ນ',
			promotions: 'ລາຍການສົ່ງເສີມການຂາຍ',
			onView:'ເບິ່ງລາຍການ',
			collectSite: 'bookmark ເວັບ​ໄຊ​ທ​໌​ຂອງ​ພວກ​ເຮົາ​',
			applyFor: 'ຮ້ອງຂໍໃຫ້ມີຮ້ານໃນໄລຍະຍາວ',
			mobileMall: 'ສູນການຄ້າມືຖື',
			shopStreet: 'ຖະຫນົນການຄ້າ',
			customerService: 'ບໍລິການລູກຄ້າ',
			top: 'ດີກວ່າ',
			topOne: 'ກະດານຈັດອັນດັບ', 
			footer1: 'ແນວພັນທີ່ສົມບູນ',
			footer2: 'ການຈັດສົ່ງໄວ',
			footer3: 'ສິນຄ້າຂອງແທ້',
			footer4: 'ລາຄາຕໍ່າທຸກໆມື້',
			address: "ຫ້ອງ 1101-04, Block A, Qihang Times Square, Xixian Avenue, Weiyang District, Xi'an City, Shaanxi Province",
			icp: "Xi'an Zhongbang Network Technology Co., Ltd. Shaanxi ICP No. 14011498-3",
		},
		goodsDetail:{ //商品详情
			search:'ຊອກຫາສິນຄ້າ',
			sales:'ຈໍານວນຂາຍ',
			oldPrice:'ລາຄາເດີມ',
			inventory:'ສິນຄ້າທີຍັງເຫຼືອ',
			coupons:'ຄູປອງ',
			choose:'ໄດ້ເລືອກ',
			choose1:'ກະລຸນາໃສ່ອ',
			Reviews:'ຄອນເມັນຂອງລຸກຄ້າ',
			good:'ຄອນເມັນດີ',
			details:'ລາຍລະອຽດຂອງສິນຄ້າ',
			recommend:'ສິນຄ້າແນະນຳ',
			home:'ໜ້າທໍາອິດ',
			like:'ເກັບຮວບຮວມ',
			cart:'ກະຕ່າຊື້ສິນຄ້າ',
			addCart:'ເກັບເຂົ້າກະຕ່າ',
			buyNow:'ຊື້ເລິຍ',
			soldOut:'ຂາຍໝົດແລ້ວ',
			sold: 'ຂາຍ',
			type:'ສາມາດເລືອກໄດ້ຕາມປະເພດ',
			navList:[
				{name:'ສິນຄ້າ'},
				{name:'ຄອນເມັນ'},
				{name:'ແນະນໍາ'},
				{name:'ລາຍລະອຽດ'}
			],
			select:'ສິນຄ້າທີ່ໄດ້ເລືອກ',
			clear:'ໝົດແລ້ວ',
			settle:'ໄປຊໍາລະເງິນ',
			num:'ຈໍານວນ',
			confirm:'ແນ່ນອນ',
			cancel: 'ຍົກເລີກ',
			assure:"ບໍລິການຮັບປະກັນ"
		},
		goodsList:{
			navTitle:'ລາຍການສິນຄ້າ',
			search:'ຊອກຫາຕາມຊື່ຂອງສິນຄ້າ',
			default:'ຄ່າເລີ່ມຕົ້ນ',
			price:'ລາຄາ',
			sales:'ຈໍານວນຂາຍ',
			new:'ສິນຄ້າໃໝ່',
			empty:'ໄດ້ຂາຍໝົດແລ້ວ,ລອງເບີ່ງແນວອື່ນສາ',
			no: 'ບໍ່ມີອັນໃດເຫຼືອໄວ້',
			more: 'ໂຫຼດເພີ່ມເຕີມ',
			nono: 'ຂ້າພະເຈົ້າຍັງມີເສັ້ນທາງລຸ່ມ',
			nomer: 'ບໍ່ມີຮ້ານເທື່ອ'
		},
		user:{
			navTitle:'ຂອງຂ້ອຍ',
			like:'ການເກັບຮວບຮວມຂອງຂ້ອຍ',
			integral:'ຄະແນນສະສົມຂອງຂ້ອຍ',
			coupons:'ຄູປອງ',
			orderCenter:'ສູນສັ່ງສິນຄ້າ',
			myOrder:'ໃບສັ່ງສິນຄ້າຂອງຂ້ອຍ',
			placeLogin:'ກົດເພື່ອລ໋ອກອິນ',
			orderStatus:[
				{name:'ກໍາລັງຖ້າການຢືນຢັນການຈ່າຍເງິນ'},
				{name:'ລໍຖ້າຈັດສົ່ງສິນຄ້າ'},
				{name:'ລໍຖ້າການຮັບສິນຄ້າ'},
				{name:'ລໍຖ້າການລິວິວສິນຄ້າ'},
				{name:'ບໍລິການຫຼັງການຂາຍ/ສົ່ງເງິນຄືນ'},
				{name:'ສໍາເລັດ'},
				{name:'ໄດ້ຮັບ'}
			],
			services:'ບໍລິການອື່ນ',
			address:'ບໍລິຫານທີ່ຢູ່',
			contact:'ຕິດຕາມໜ່ວຍບໍລິການລູກຄ້າ',
			applicationRecord: 'ການ​ເກັບ​ກໍາ​ຮ້ານ​ຄ້າ​',
			goodsCollection: 'ສົນທະນາ',
			record: 'ບັນທຶກຄໍາຮ້ອງສະຫມັກ',
			mineNav: [
				{name: 'ໃບສັ່ງສິນຄ້າຂອງຂ້ອຍ'},
				{name: 'ລາຍຊື່ການຄືນເງິນ'},
				{name: 'ກວດເບິ່ງລາຍການ'}
			],
			qunTitle: 'ຂໍ້ມູນໃບອະນຸຍາດທຸລະກິດ',
			qunDesc: 'ອີງຕາມຂໍ້ກໍານົດຂອງການບໍລິຫານລັດສໍາລັບອຸດສາຫະກໍາແລະການຄ້າ "ມາດຕະການການຄຸ້ມຄອງທຸລະກໍາອອນໄລນ໌", ຂໍ້ມູນໃບອະນຸຍາດທຸລະກິດຮ້ານຄ້າອອນໄລນ໌ໄດ້ຖືກເຜີຍແຜ່ເປັນສາທາລະນະດັ່ງຕໍ່ໄປນີ້:',
			qunCode: 'ກະລຸນາໃສ່ລະຫັດຢືນຢັນຮູບພາບ',
			submit: 'ສົ່ງ',
		},
		goodsSearch:{
			navTitle:'ຊອກຫາສິນຄ້າ',
			place:'ກົດເພື່ອຊອກຫາສິນຄ້າ',
			search:'ຊອກຫາ',
			hotSearch:'ສິນຄ້າທີ່ມີການຄົ້ນຫາຫຼາຍທີ່ສຸດ',
			recommend:'ແນະນໍາສິນຄ້າຂາຍດີທີ່ສຸດ',
			emptySearch:'ບໍ່ມີເງື່ອນໄຂໃນການຊອກ,ລອງຄໍາອື່ນສາ',
			placeSearch:'ກະລຸນາໃສ່ຜະລິດຕະພັນທີ່ທ່ານຕ້ອງການຄົ້ນຫາ',
			onSearch:'ກຳລັງຊອກຫາ',
			goods:'ສິນຄ້າ',
			mer: 'ຮ້ານ',
			merchantType: 'ປະເພດຮ້ານ',
			merchantClassify:'ການ​ຈັດ​ປະ​ເພດ​ຜູ້​ຄ້າ​',
			sure :'ແນ່ນອນ',
			reset: 'ຣີເຊັດ',
			open: 'ຂະຫຍາຍທັງໝົດ',
			up: 'ເອົາໄປ',
			sort: 'ຄັດ',
			Default: 'ຄ່າເລີ່ມຕົ້ນ',
			Seller: 'ການຂາຍ',
			Price: 'ລາຄາ',
			searchMer: 'ຂໍອະໄພ, ບໍ່ພົບຮ້ານທີ່ທ່ານຊອກຫາ~',
			searchGoods: 'ຂໍອະໄພ, ບໍ່ພົບຫຍັງທີ່ກ່ຽວຂ້ອງກັບການຄົ້ນຫາຂອງທ່ານ~',
		},
		goodsAddcart:{
			navTitle:'ກະຕ່າຊື້ສິນຄ້າ',
			labelNav:'ຮັບປະກັນຄຸນນະພາບສິນຄ້າ100% ແລະ ບໍລິການຫຼັງການຂາຍ100%',
			buyNum:'ຈໍານວນການສັ່ງຊື້',
			management:'ບໍລິຫານ',
			cancel:'ຍົກເລີກ',
			attribute:'ຄຸນລັກສະນະ',
			failureGoods:'ສິນຄ້າທີ່ໝົດອາຍຸແລ້ວ',
			empty:'ສິນຄ້າໝົດສະຕ໋ອກ',
			failure:'ບໍ່ຖືກຕ້ອງ',
			fallDesc:'ສິນຄ້າອັນນີ້ທີ່ໝົດອາຍຸແລ້ວ',
			selectAll:'ເລືອກທັງໝົດ',
			buyNow:'ສັ່ງດ່ຽວນີ້',
			like:'ເກັບຮວບຮວມ',
			delete:'ລົບລ້າງ',
			emptyCart:'ຍັງບໍ່ມີສິນຄ້າ,ໄປສັ່ງສິນຄ້າອື່ນສາ',
			again: 'ກະລຸນາເລືອກຂໍ້ມູນສະເພາະຂອງຜະລິດຕະພັນຄືນໃໝ່',
			reselect :'ການເລືອກຕັ້ງຄືນໃໝ່',
			productInfo: 'ຂໍ້ມູນສິນຄ້າ',
			unitPrice: 'ລາຄາຫຼືດ',
			quantity: 'ຈໍານວນ',
			total: 'ລາຄາທີ່ທີ່ຈ່າຍ',
			operate: 'ການເດືອນ',
			orderInfo: 'ຂໍ້ມູນໃບສັ່ງຊື້',
		},
		orderPayStatus:{
			success:'ຊໍາລະເງິນສໍາເລັດ',
			fail:'ຊໍາລະເງິນລົ້ມເຫຼວ',
			orderId:'ເລກທີໃບສັ່ງຊື້',
			orderTime:'ເວລາການສັ່ງ',// order of time
			payType:'ວິທີການຊໍາລະເງິນ',
			payPrice:'ຍອດເງິນທີ່ຊໍາລະ', //Pay the amount
			failReason:'ສາເຫດຂອງການລົ້ມເຫຼວ', //The reason for failure
			viewOrder:'ກວດເບີ່ງລາຍການສັ່ງສິນຄ້າ',//To view the order
			backHome:'ກັບຄືນໜ້າທໍາອິດ'
		},
		orderDetails:{
			navTitle:'ລາຍລະອຽດຂອງການສັ່ງ',
			item:'ຈໍານວນສິນຄ້າ',// item(s)
			Customer:'ຕິດຫາບໍລິການລູກຄ້າ',
			orderId:'ເລກທີໃບສັ່ງຊື້',
			copy:'ສໍາເນົາ',
			orderTime:'ເວລາໃນການສັ່ງ',
			refundTime: 'ເວລາຄືນເງິນ',
			payStatus:'ສະຖານະການຊໍາລະເງິນ',
			payTrue:'ໄດ້ຊໍາລະເງິນເລ້ວ',
			payFalse:'ບໍ່ໄດ້ຊໍາລະເງິນເທື່ອ',
			payType:'ວິທີການຊໍາລະເງິນ',
			message:'ບັນທຶກຂໍ້ຄວາມຂອງຜູ້ຊື້',
			name:'ຜູ້ຮັບ',
			phone:'ເບີໂທຕິດຕໍ່',
			address:'ທີ່ຢູ່ຮັບສິນຄ້າ',
			returnReason:'ສາເຫດໃນການຂໍເງິນຄືນ',
			returnMsg:'ອະທິບາຍລາຍລະອຽດໃນການຂໍເງິນຄືນ',
			returnImg: 'ບັດເຕີມເງິນຄືນ',
			sendMethod:'ວິທີການສົ່ງສິນຄ້າ',
			sendOne:'ການຈັດສົ່ງສິນຄ້າ', //send
			sendTwo:'ການສົ່ງສິນຄ້າ', //The delivery
			CourierCompany:'ບໍລິສັດ ຂົນສົ່ງດ່ວນ',//Courier company
			CourierNo:'ເລກທີບິນຮັບພັດສະດຸ', //Courier number
			deliveryName:'ຊື່ຂອງຜູ້ສົ່ງ',
			deliveryPhone:'ເບີໂທຕິດຕໍ່',
			Virtual:'ການຈັດສົ່ງຕາມຈິງ',//Virtual delivery
			deliveryMsg:'ຈັດສົ່ງຮຽບຮ້ອຍແລ້ວ,ກະລຸນາກວດຮັບໃຫ້ດີເດີ',
			allPrice:'ຈໍານວນເງິນທັງໝົດຂອງສິນຄ້າ',
			freight:'ຄ່າສົ່ງ',
			coupon:'ການໃຊ້ຄູປອງສ່ວນຫຼຸດ', //Coupon deduction
			point:'ການໃຊ້ຄະແນະເພື່ອເປັນສ່ວນຫຼຸດ', //Points deduction
			actualPayment:'ຊໍາລະເງິນຕົວຈິງ',//actual payment
			cancelOrder:'ຍົກເລີກສິນຄ້າທີ່ສັ່ງ',
			nowPay:'ຊໍາລະເງິນເລີຍ',
			refund:'ສະເໜີຂໍເງິນຄືນ',
			logistics:'ກວດເບີ່ງພັດສະດຸ',
			confirm:'ຢັ້ງຢືນການຮັບສິນຄ້າ',
			delete:'ລົບການສັ່ງຊື້',
			again:'ສັ່ງຊື້ອີກເທື່ອ',
			confirmInfo: 'ເພື່ອປົກປ້ອງສິດແລະຜົນປະໂຫຍດ, ກະລຸນາຢືນຢັນການຮັບສິນຄ້າຫຼັງຈາກຢືນຢັນວ່າສິນຄ້າຖືກຕ້ອງ.',
			confirmDel: 'ຕົກລົງເພື່ອລຶບຄຳສັ່ງນີ້',
			confirmCancel: 'ຢືນຢັນການຍົກເລີກຄໍາສັ່ງ'
		},
		users:{
			userInfo:{
				navTitle:'ຕິດຕັ້ງ',
				avatar:'ຮູບໂປຣຟາຍ',
				name:'ຊື່ຫຼີ້ນ',
				email:'ອີ່ແມວ',
				password:'ລະຫັດ',
				save:'ບັນທຶກການປ່ຽນຂໍ້ມູນ',
				logOut:'ອອກຈາກລະບົບ',
				phone:'ເບີໂທ',
				msg: 'ຊື່ນຳໃຊ້ບໍ່ສາມາດເປົ່າ',
				personalCenter: 'ສູນ​ສ່ວນ​ບຸກ​ຄົນ​',
			},
			orderConfirm:{
				setAddress:'ກໍານົດທີ່ຢູ່ຮັບສິນຄ້າ',
				navTitle:'ສັ່ງຊື້ສິນຄ້າ',
				items:'ຈໍານວນສິນຄ້າ',
				coupons:'ຄູປອງ',
				integral:'ການໃຊ້ຄະແນະເພື່ອເປັນສ່ວນຫຼຸດ',
				freight:'ຄ່າສົ່ງ',
				note:'ໝາຍເຫດ',
				payPal:'ຈ່າຍ',
				allPrice:'ລວມມູນຄາຂອງສິນຄ້າ',
				remaining:'ຄະແນະທີ່ຍັງເຫຼືອ',
				newIntegral:'ຄະແນນປະຈຸບັນ',
				free:'ສົ່ງຟຣີ',
				placeNote:'ເພີ່ມໝາຍເຫດ(ພາຍໃນ 150 ຕົວໜັງສື)',
				CouponDeduction:'ການໃຊ້ຄູປອງສ່ວນຫຼຸດ',
				total:'ລວມເງິນ',
        payment: 'ກະລຸນາໃສ່ແຜ່ນດີສສຳລັບສຳລັບຜູ້ຊ່ອງໂປຣເເກຣມ',
        paymentResults: 'ຈຸດເຊີ່ອມ',
        paymentResultsNo: 'ບໍ່ຈ່າຍພາຍໃຕ້',
			},
			orderList:{
				navTitle:'ໃບສັ່ງສິນຄ້າຂອງຂ້ອຍ',
				orderNum:'ໃບສັ່ງສິນຄ້າ', //Cumulative order
				total:'ລວມເງິນ',//Total consumption
				orderStatus:[
					{name:'ກໍາລັງຖ້າການຢືນຢັນການຈ່າຍເງິນ'},
					{name:'ລໍຖ້າຈັດສົ່ງສິນຄ້າ'},
					{name:'ລໍຖ້າການຮັບສິນຄ້າ'},
					{name:'ລໍຖ້າການລິວິວສິນຄ້າ'},
					{name:'ບໍລິການຫຼັງການຂາຍ/ສົ່ງເງິນຄື່ນ'},
				],
				item:'ຈໍານວນສິນຄ້າ',// item(s)
				totalPay:'ຈໍານວນເງິນທັງໝົດ',//total payment
				cancelOrder:'ຍົກເລີກສິນຄ້າທີ່ສັ່ງ',
				viewDetails:'ກວດເບີ່ງລາຍລະອຽດ',
				evaluation:'ໄປປະເມີນ',//evaluation
				evaluated:'ປະເມີນ',//evaluation
				delete:'ລົບການສັ່ງຊື້',
				empty:'ຍັງບໍ່ມີຂໍ້ມູນການສັ່ງຊື້',
				pay:'ຊໍາລະເງິນເລີຍ',
				complete:'ສໍາເລັດ'
			},
			userCoupon:{
				navTitle:'ຄູປອງຂອງຂ້ອຍ',
				available:'ຍັງບໍ່ໄດ້ນໍາໃຊ້',
				expired:'ໄດ້ນໍາໃຊ້ແລ້ວ/ໝົດອາຍຸການນຳໃຊ້',
				min:'ຫຼຸດເຕັມທີ່',
				can:'ສາມາດນໍາໃຊ້ໄດ້',
				used:'ໝົດອາຍຸ',
				general:'ໃຊ້ໄດ້ທົ່ວໄປ',
				goods:'ສິນຄ້າ',
				cate:'ປະເພດສິນຄ້າ',
				receive:'ຮັບເອົາທັນທີ່',
				received:'ໄດ້ຮັບແລ້ວ',
				receivedInfo:'ຫຼັງຈາກໄດ້ຮັບ',
				receivedInfo1:'ມີໃຫ້ພາຍໃນມື້',
				navList:[
					{name:'ພໍ່ຄ້າ'},
					{name:'ສິນຄ້າ'},
					{name:'ປະເພດສິນຄ້າ'},
				],
				empty:'ຍັງບໍ່ມີຄູປອງ',
				valid:'ສາມາດນໍາໃຊ້ໄດ້ເຖິງ',
				day:'ມື້',
        minus: 'minus',
        getUsers: 'ການ​ນໍາ​ໃຊ້'
			},
			userGoodsCollection:{
				navTitle:'ສະຕ໋ອກຂອງຂ້ອຍ',
				item:'ຈໍານວນສິນຄ້າ',
				management:'ບໍລິຫານ',
				cancel:'ຍົກເລີດ',
				empty:'ຍັງບໍ່ໄດ້ເກັບຮວບຮວມສິນຄ້າ,ຮິດຕິດຕາມສາ'
			},
			userAddressList:{
				navTitle:'ທີ່ຢູ່ການຈັດການ',
				default:'ຕັ້ງເປັນຄ່າເລີ່ມຕົ້ນ',
				add:'ເພີ່ມທີ່ຢູ່ໃໝ່',
				emptyAddress:'ຍັງບໍ່ມີຂໍ້ມູນຂອງທີ່ຢູ່',
        edit:'ປັບ',
        del:'ລຶບ',
        sureDel: 'ເເນ່ທີ່ຈະລຶບ'
			},
			userAddress:{
				navTitle:'ທີ່ຢູ່ການຈັດການ',
				name:'ຊື່ແລະນໍາສະກຸນ',
				Email:'ອີ່ແມວ',
				country:'ປະເທດ/ເຂດ',
				address:'ລາຍລະອຽດຂອງທີ່ຢູ່',
				postCode:'ເລກທີໄປສະນີ',
				phone:'ເບີໂທ',
				default:'ຕັ້ງເປັນຄ່າເລີ່ມຕົ້ນ',
				save:'ບັນທຶກ',
				place:'ກະລຸນາຕື່ມຂໍ້ມູນ'
			},
			userReturnList:{
				navTitle:'ສະເໜີຂໍສົ່ງສິນຄ້າຄືນ',
				orderId:'ເລກທີ່ໃບສັ່ງຊື້',
				item:'ຈໍານວນສິນຄ້າ',
				total:'ຈໍານວນເງິນທັງໝົດ ',
				refunding:'ການຄືນເງິນ...',
				refunded:'ສົ່ງເງິນຄືນແລ້ວ',
				examine: 'ຜູ້ຂາຍກຳລັງຖືກກວດສອບ',
				examineInfo: 'ທ່ານໄດ້ລິເລີ່ມການສົ່ງເງິນຄືນສຳເລັດແລ້ວ, ກະລຸນາລໍຖ້າໃຫ້ຜູ້ຄ້າດຳເນີນມັນດ້ວຍຄວາມອົດທົນ; ກະລຸນາເຈລະຈາກັບຜູ້ຄ້າກ່ອນທີ່ຈະສົ່ງເງິນຄືນ, ເຊິ່ງຈະຊ່ວຍແກ້ໄຂບັນຫາຫຼັງການຂາຍໄດ້ດີຂຶ້ນ.',
			    examine1: 'ສົ່ງເງິນຄືນໃຫ້ຜູ້ຂາຍແລ້ວ',
				refuse: 'ປະຕິເສດການຄືນເງິນ',
				refuseReason: 'ເຫດຜົນການປະຕິເສດ：',
				refuseReason2: 'ການຄືນເງິນໄດ້ຖືກຍອມຮັບຢ່າງສໍາເລັດຜົນ. ຖ້າຜູ້ຄ້າໄດ້ສົ່ງສິນຄ້າແລ້ວ, ກະລຸນາສົ່ງຄືນມັນໄວເທົ່າທີ່ເປັນໄປໄດ້; ຂອບໃຈສໍາລັບການສະຫນັບສະຫນູນຂອງທ່ານ',
			},
			goodsCommentList:{
				navTitle:'ລີວິວສິນຄ້າ',
				score:'ຕີຄະແນນ',
				good:'ອັດຕາຂອງຄອນເມັນດີ',
				all:'ທັງໝົດ',
				goodScore:'ລິວິວດີ',
				general:'ພໍດີ',
				bad:'ບໍ່ດີ',
				attribute:'ຂະໜາດ',
				seller:'ພະນັກງານຂາຍ'
			},
			goodsCommentCon:{
				navTitle:'ລີວິວສິນຄ້າ',
				score:[
					{name:'ຄຸນນະພາບສິນຄ້າ'},
					{name:'ທ່າທີວາງໂຕໃນການໃຫ້ບໍລິການ'}
				],
				place:'ສິນຄ້າຖືກຕາມຄວາມຕ້ອງການຂອງທ່ານບໍ່?ເວົ້າໃນສິ່ງທີ່ເຈົ້າຄິດ,ເພື່ອແບ່ງປັນປະສົບການໃຫ້ຄົນທີ່ຢາກຊື້' ,
				upload:'ອັບໂຫລດຮູບ',
				submit:'ໃຫ້ຄະແນນເລີຍ',
				tips: 'ຂອບໃຈສໍາລັບການປະເມີນຜົນຂອງທ່ານ',
				tipsWrite: 'ກະລຸນາຕື່ມຂໍ້ມູນໃສ່ໃນປະສົບການຂອງເດັກນ້ອຍຂອງທ່ານ!',
        SU: 'ການສຶກສາທີ່ສຳເລັບຜົນອອກ',
        tipsSU:'ພວກເຮົາຕ້ອງຍັງຕໍ່ຕ້ອງສະຫນອງຂໍ້ມູນທີ່ດີກວ່າ ແລະ ບໍ່ລິການ'
			},
			goodsReturn:{
				navTitle:'ສະເໜີຂໍເງິນຄືນ', //Application for return
				number:'ຈໍານວນສິນຄ້າຮຽກຄືນ',
				price:'ຈໍານວນເງິນຮຽກຄືນ',
				reason:'ສາເຫດໃນການຮຽກເງິນຄືນ',
				info:'ຄູ່ມືການໃຊ້ງານ',
				voucher:'ອັບໂຫລດໃບຢັ້ງຢືນ',
				place:'ເພີ່ມໝາຍເຫດ(ພາຍໃນ 100 ຕົວໜັງສື)',
				submit:'ສະເໜີຮຽກເງິນຄືນ' ,//Request a refund
				upload:'ອັບໂຫລດໃບຢັ້ງຢືນ',
        detal:'ຂໍ້ມູນລາຍລະອຽດແຍ້ງ',
        information: 'ຂໍ້ມູນອ້າງອີງ',
        refundList: 'ຂໍ້ມູນເລຍຂໍ້ມູນ'
			},
			login:{
				placeEmail:'ກະລຸນາຂຽນອີແມວ',
				placePasd:'ກະລຸນາຕື່ມລະຫັດ',
				sign:'ລ໋ອກອິນ',//SIGN IN
				create:'ຕິດຕັ້ງບັນຊີ', //Create account
				forget:'ລື່ມລະຫັດ',
				quick:'ລ໋ອກອິນດ່ວນ',
				pasdLogin:'ລ໋ອກອິນດ້ວຍລະຫັດ',
				with:'ບຸກຄົນທີສາມທີ່ລ໋ອກອິນ',
				Pasdagain:'ກະລຸນາຢັ້ງຢືນລະຫັດ',
				submit:'ສົ່ງ',
				next:'ຂັ້ນຕອນຕໍ່ໄປ',
				reset:'ຕັ້ງລະຫັດໃໝ່',
				resetDesc:"ກະລຸນາຂຽນອີແມວໃສ່ເພື່ອຮັບເລກຢັ້ງຢືນ ",
				emailVer:"ຢັ້ງຢືນດ້ວຍອີ່ແມວ",
				verDesc:'ກະລຸນາກວດຄືນອີ່ເມວຂອງທ່ານໃຫ້ຖືກຕ້ອງເພື່ອຄວາມປອດໄພ',
				tourists:'ຈັດຊື້ໂດຍບໍ່ບອກຊື່',
				continue:'ດຳເນີນການຕໍ່',
				phoneVer:'ຢັ້ງຢືນດ້ວຍເບີໂທ',
        remember: 'ຈື່ລະຫັດຜ່ານຂອງເຈົ້າບໍ?'
			},
			register:{
				tabNav:[
					{name:'ອີ່ເມວ'},
					{name:'ເບີໂທລະສັບ'}
				],
				placeEmail:'ກະລຸນາຂຽນອີເມວ',
				placeCode:'ກະລຸນາຂຽນເລກຢັ້ງຢືນ',
				placePhone:'ກະລຸນາຂຽນເບີໂທລະສັບ',
				submit:'ລົງທະບຽນ',
				have:'ມີບັນຊີແລ້ວ？',
				sign:'ໄປລ໋ອກອິນ'
			},
			logistics:{
				navTitle:'ລາຍລະອຽດຂອງພັດສະດຸ',
				expName:'ບໍລິສັດ ຂົນສົ່ງດ່ວນ',
				expNo:'ເລກທີບິນຮັບພັດສະດຸ',
			},
			userIntegral:{
				now:'ຄະແນນປະຈຸບັນ',
				totalInt:'ສະສົມຄະແນນ',
				totalPay:'ລວມເງິນສະສົມ',
				freeze:'ຄະແນນຖືກລະງັບການນຳໃຊ້',
				tabNav:[
					{name:"ລາຍລະອຽດຂອງຄະແນນ"},
					{name:"ເພີ່ມຄະແນນ"},
				],
				shopAdd:'ການຊື້ສິນຄ້າເພື່ອຮັບຄະແນນເປັນໂບນັດ',
				make:'ຮັບຄະແນນ',
				empty:'ຍັງບໍ່ມີບັນທຶກການນໍາໃຊ້ຄະແນນ'
			},
			replyList: {
				navTitle: 'ທົບທວນລາຍການ'
			},
			wallet: {
				navTitle: 'ທົບທວນລາຍການ',
				all: 'ທັງຫທົບທວນລາຍການ',
				income: 'ລາຍການເລີຍ',
				spending: 'ລາຍການຈໍານວນ',
				tableColumn: {
					type: 'ປະເພດ',
					amount: 'ຈຳນວນ',
					time: 'ວັນທີ'
				}
			},
			invoiceList: {
				navTitle: 'ລາຍລະອຽດຂອງການໃຫ້ຄົນທີ່ຢາກຊື້',
				openedCount: 'ການໃຫ້ຄົນທີ່ຢາກຊື້',
				applyingCount: 'ການໃຫ້ຄົນທີ່ຢາກຊື້',
				orderNum: 'ລະຫັດການສຳລັບ',
				tableColumn: {
					info: 'ຂໍ້ມູນການໃຫ້ຄົນທີ່ຢາກຊື້',
					amount: 'ຈຳນວນ',
					title: 'ການໃຫ້ຄົນທີ່ຢາກຊື້',
					type: 'ປະເພດ',
					date: 'ວັນທີ',
					status: 'ການຈັດອັນດັບ',
					actions: 'ການຈັດອັນດັບ'
				},
				actionBtn: {
					viewInvoice: 'ການໃຫ້ຄົນທີ່ຢາກຊື້',
					orderDetails: 'ລາຍລະອຽດຂອງການສຳລັບ'
				}
			}
		},
		store: {
			search: 'ຊອກຫາຮ້ານຄ້າ',
			followed: 'ຕິດຕາມ',
			follow: 'ຈຸດ​ສຸມ',
			storeRating: 'ການຈັດອັນດັບຮ້ານ',
			storeQualification: 'ຄຸນສົມບັດຂອງຮ້ານ',
			storeIntroduction: 'ແນະນຳຮ້ານ',
			storeAddress: 'ທີ່ຢູ່ຮ້ານ',
			storePhone: 'ເບີໂທຕິດຕໍ່',
			storeService: 'ຕິດຕາມໜ່ວຍບໍລິການລູກຄ້າ',
			storeTime: 'ເວລາເປີດຮ້ານ',
			storeName: 'ຊື່​ທຸ​ລະ​ກິດ',
			userName: 'ຊື່ຜູ້ໃຊ້',
			phone: 'ເບີໂທຕິດຕໍ່',
			emil:'ທີ່​ຢູ່​ອີ​ເມວ',
			code: 'ລະຫັດຢືນຢັນ',
			getCode: 'ໄດ້ຮັບລະຫັດຢືນຢັນ',
			class:'ການ​ຈັດ​ປະ​ເພດ​ຜູ້​ຄ້າ​',
			type:'ປະເພດຮ້ານ',
			place1:'ກະລຸນາອັບໂຫລດຮູບພາບຂອງໃບອະນຸຍາດດ້ານທຸລະກິດແລະໃບຢັ້ງຢືນຄຸນນະພາບ',
			place2:'ຮູບພາບດັ່ງກ່າວສາມາດອັບໂຫລດໄດ້ເຖິງ 10 ຮູບ, ແລະຮູບແບບຮອງຮັບ JPG, PNG, JPEG',
			agree:'ອ່ານແລະຕົກລົງເຫັນດີ',
			agreement:'ຂໍ້ຕົກລົງການຄອບຄອງ',
			submit:'ຍື່ນໃບສະຫມັກ',
			agreement2:'ຂໍ້ຕົກລົງການຕັ້ງຖິ່ນຖານຂອງພໍ່ຄ້າ',
			Tips1:'ຂໍສະແດງຄວາມຍິນດີ, ຂໍ້ມູນຂອງທ່ານໄດ້ຖືກສົ່ງໄປແລ້ວ!',
			Tips2:'ຄາດວ່າການທົບທວນຄືນຈະສໍາເລັດພາຍໃນ 15 ວັນເຮັດວຽກ, ແລະການບໍລິການລູກຄ້າຂອງເວທີຈະຕິດຕໍ່ຫາທ່ານໃນເວລາ!',
			Tips3:'ກັບຄືນຫນ້າທໍາອິດ',
			title1:'ພໍ່ຄ້າໄດ້ຕົກລົງ',
			title2:'ມາຮ່ວມກັບພວກເຮົາ',
			street: 'ຮ້ານຖະຫນົນຮ້ານ',
			keyword: 'ຄໍາສໍາຄັນ',
			merInfo: 'ລາຍລະອຽດຂອງຮ້ານ',
			index: 'ຫນ້າທາງຫນ້າ',
			classify: 'ຈໍາແນກ',
			collar: 'ຮັບຄູປອງ',
			call: 'ຕິດຫາບໍລິການລູກຄ້າ',
			people: 'ປະ​ຊາ​ຊົນ​ປະ​ຕິ​ບັດ​ຕາມ​',
			delFollow: 'ເຊົາຕິດຕາມ',
			selfSupport: 'ຕົນເອງເຮັດວຽກ',
      homeNav: [
        {name: 'ຫນ້າທາງຫນ້າ'},
        {name: 'ຈໍາແນກ'},
        {name: 'ຮັບຄູປອງ'}
      ]
		}
	},
	message:{
		login:{
			loginLoading:'ກໍາລັງລ໋ອກອິນ',
			getting:'ກໍາລັງຮອງຮັບ',
			emailEmpty:'ກະລຸນາຂຽນອີເມວ',
			correctEmail:'ກະລຸນາຂຽນອີເມວໃຫ້ຖືກຕ້ອງ',
			emptyPassword:'ກະລຸນາຂຽນລະຫັດ',
			againPassword:'ກະລຸນາຢັ້ງຢືນລະຫັດ',
			diffPassword:'ລະຫັດທັງສອງບໍ່ຕົງກັນ',
			emptyPhone:'ກະລຸນາຂຽນເບີໂທ',
			emptyCaptche:'ກະລຸນາຂຽນເບີຢັ້ງຢືນ',
			correctCaptche:'ກະລຸນາຂຽນເບີຢັ້ງຢືນໃຫ້ຖືກຕ້ອງ',
			loginSuccess:'ເຂົ້າສູ່ລະບົບສໍາເລັດ',
			resetSuccess:'ສໍາເລັດໃນການຕັ້ງລະຫັດໃໝ່',
			name:'ກະລຸນາຂຽນຊື່ຜູ້ຮັບ',
			detail:'ກະລຸນາຂຽນລາຍລະອຽດທີ່ຢູ່',
			postCode:'ກະລຸນາຂຽນເລກໄປສະນີ',
			save:'ກໍາລັງບັນທືກ',
			updateSU:'ການປ່ຽນຂໍ້ມູນສໍາເລັດແລ້ວ',
			saveSU:'ບັນທຶກສໍາເລັດ',
			prompt:'ການແຈ້ງເຕືອນ',
			confirmDel:'ຍົກເລີກແນ່ນອນບໍ??',
			logout:'ທ່ານແນ່ໃຈວ່າຈະອອກຈາກລະບົບບໍ?',
			notExist:'ບໍ່ມີທີ່ຢູ່ທີ່ທ່ານຕັ້ງໄວ້',
			setSU:'ຕິດຕັ້ງສໍາເລັດ',
			delSU:'ສໍາເລັດໃນການລົບລ້າງ',
			calSU:'ຍົກເລີກຄວາມສໍາເລັດ',
			send:'ສົ່ງ',
			resend:'ສົ່ງໃໝ່',
			remaining:'ຍອດເຫຼືອ',
			operationSU: 'ການດໍາເນີນງານສົບຜົນສໍາເລັດ',
			loginSure: 'ທ່ານໃຊ້ລະຫັດຜ່ານນີ້ເພື່ອເຂົ້າສູ່ລະບົບຫຼັງຈາກດັດແກ້ບໍ?？',
			loginFacebook:'ຜູ້ໃຊ້ໃນປະຈຸບັນບໍ່ສາມາດເຂົ້າສູ່ລະບົບ Facebook ຫຼື Webmage ຂອງທ່ານ',
      registerSU:'ຂຽນໂປຣເເກຣມ',
      agreement: 'ກະລຸນາໃສ່ຄວາມຮູ້ສ່ວນຕົວ',
      agree: 'ຂ້ອຍອ່ານແລະຂ້ອຍເຂົ້າຮ່ວມ',
      agreementName: 'ຂໍ້ມູນເພີ້ມຄຳໃຊ້'
		},
		pay:{
			orderFail:'ຊໍາລະເງິນລົ້ມເຫຼວ',
			error:'ກວດເບີ່ງຖານະການຊໍາລະຄ່າສິນຄ້າບໍ່ໄດ້ ເພາະຂາດຂໍ້ມູນ',
			errorOrder: 'ບໍ່ສາມາດເບິ່ງໝາຍເລກການສັ່ງຊື້ທີ່ຂາດຫາຍໄປໄດ້'
		},
		orderConfirm:{
			payType:'ກະລຸນາເລືອກວິທີໃນການຊໍາລະ',
			emptyAddress:'ກະລຸນາເລືອກທີ່ຢູ່ຈັດສົ່ງ',
			payLoading:'ກໍາລັງຊໍາລະເງິນ',
			productInfo: 'ຂໍ້ມູນສິນຄ້າ'
		},
		tips: {
			time: 'ເວລາຍື່ນສະເຫນີ',
			adopt:'ການກວດກາຜ່ານ',
			noadopt: 'ການທົບທວນຄືນຂອງຄວາມລົ້ມເຫຼວທີ່ຈະຜ່ານ',
			reason: 'ເຫດ​ຜົນ',
			stay: 'ລໍຖ້າການທົບທວນຄືນ',
			edit: 'ແກ້ໄຂ',
			see: 'ກວດກາ',
			again: 'ສົ່ງໃໝ່',
			shoppingSU: 'ເພີ່ມໃສ່ກະຕ່າສຳເລັດແລ້ວ',
			loding: 'ກໍາລັງໂຫລດ...',
			selectAddress: 'ທີ່ຢູ່ທາງເລືອກ',
			selectOther: 'ເລືອກທີ່ຢູ່ອື່ນ',
			surePay: 'ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການຈ່າຍຄ່າສັ່ງຊື້ຂອງທ່ານ?',
			sureDel: 'ຕົກລົງທີ່ຈະລຶບຄໍາສັ່ງ',
			upPic:'ເຂົ້າຮ່ວມເຂົ້າຮ່ວມໄດ້ເພື່ອ5 ຂໍ້ມູນ',
			edidM: 'ອັບໂຫລດ 3 ຮູບພາບໃຫຍ່',
			sold: 'ຂາຍ',
			changeGoods: 'ກະລຸນາໃສ່ອີກໂຕເລືອກ',
			picTips: 'ໂຕເລືອກໃນການຂໍ້ມູນປັບປຸງຂໍ້ມູນ',
			noEvaluation: 'No comment~',
			more: 'ສະແດງເພີ່ມເຕີມ',
			hide: 'ເຊື່ອງຫຼາຍ',
			noDetal: 'ບໍ່ມີລາຍລະອຽດຂອງຜະລິດຕະພັນເທື່ອ',
      getSU: 'ໄດ້ຮັບສຳເລັດແລ້ວ',
      browser: 'ເນື່ອງຈາກການເຮັດວຽກທີ່ຈໍາກັດຂອງຕົວທ່ອງເວັບ 360 ​​, ກະລຸນາກົດ Ctrl+D ເພື່ອລວບລວມຂໍ້ມູນດ້ວຍຕົນເອງ!',
      nubrowser: 'ບຣາວເຊີຂອງທ່ານບໍ່ຮອງຮັບມັນ, ກະລຸນາກົດ Ctrl+D ເພື່ອເພີ່ມດ້ວຍຕົນເອງ!',
      error1: 'ຂໍອະໄພ, ມີຂໍ້ຜິດພາດໃນໜ້າເວັບທີ່ທ່ານເຂົ້າເບິ່ງ',
      error2: 'ໂຫຼດບໍ່ສຳເລັດ',
      error3:'ຄໍາ​ຮ້ອງ​ສະ​ຫມັກ​ທີ່​ບໍ່​ດີ​',
      error4:'ກະລຸນາກວດເບິ່ງໄຟລ໌ config ຂອງທ່ານ',
      placeLogin: 'ກະລຸນາເຂົ້າສູ່ລະບົບ'
		},
		settled: {
			emptyName:"ກະລຸນາໃສ່ຊື່ຂອງວິສາຫະກິດ",
			emptyRealName:"ກະລຸນາພິມຊື່ຂອງທ່ານ",
			emptyCaptcha:"ກະລຸນາຂຽນເບີຢັ້ງຢືນ",
			emptyCategory:"ກະລຸນາເລືອກໝວດໝູ່ຜູ້ຄ້າ",
			emptyIsAgree:"ກະລຸນາໝາຍຕິກ ແລະຕົກລົງເຫັນດີກັບສັນຍາອາຊີບ",
			emptyIsPicture:"ກະລຸນາອັບໂຫຼດຮູບຄຸນສົມບັດ",
			appleTips: 'ບໍ່ມີບັນທຶກການສະຫມັກ, ໄປແລະສະຫມັກສໍາລັບການເຂົ້າຮຽນ'
		}
	}
}
